import React, { useState, useRef, useEffect } from "react";
import { Button } from "react-bootstrap";
import http from "../../services/HttpService";
import config from "../../config.json";

const MsgWithApplicantPopup = ({ handleAddNewMessage }) => {
  const fileInputRef = useRef(null);

  const [message, setMessage] = useState("");
  const [documents, setDocuments] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [templateId, setTemplateId] = useState("");
  const [msgType, setMsgType] = useState("");
  const [cannedMessages, setCannedMessages] = useState([]);
  const [isDragging, setIsDragging] = useState(false);

  const messageTypes = [
    { id: 1, name: "Enrollment/Onboarding" },
    { id: 2, name: "ACH Information" },
    { id: 3, name: "Insurane Information" },
    { id: 4, name: "Contract" },
    { id: 5, name: "Purchase Orders" },
    { id: 6, name: "Documents" },
    { id: 7, name: "Invoices" },
    { id: 8, name: "Engagement/Termination" },
    { id: 9, name: "Contract Termination" },
    { id: 10, name: "Engagement Extention" },
    { id: 11, name: "Payments" },
    { id: 12, name: "Others" },
  ];

  // Fetch canned messages (if needed)
  useEffect(() => {
    // Example:
    // const fetchCannedMessages = async () => {
    //   const { data } = await http.get(config.GetCodemanager + "Canned Message");
    //   setCannedMessages(data);
    // };
    // fetchCannedMessages();
  }, []);

  const messgeOnFileChange = (event) => {
    const docs = [...documents];
    for (const file of event.target.files) {
      const doc = {
        name: file.name,
        type: file.type,
        file: file, // Store the actual file
        size: file.size // File size in KB
      };
      docs.push(doc);
    }
    setDocuments(docs);
  };

  const handleFileRemove = (file) => {
    setDocuments((prevDocs) => prevDocs.filter((doc) => doc.name !== file.name));
  };

  const handleSubmit = () => {
    handleAddNewMessage(message, documents, msgType);
    setMessage("");
    setDocuments([]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files);
    const docs = files.map(file => ({
      name: file.name,
      type: file.type,
      size: (file.size / 1024).toFixed(2),
      file: file,
    }));
    setDocuments(prev => [...prev, ...docs]);
  };

  const handleTemplateChange = (e) => {
    setTemplateId(e.target.value);
  };

  const handleCannedMessage = (e) => {
    setMessage(e.target.value);
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <div
          className={`drop-zone w-100 p-4 mb-3 text-center border rounded ${isDragging ? "bg-light" : ""}`}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          onClick={() => fileInputRef.current.click()}
          style={{
            border: "2px dotted #ccc",
            borderRadius: "8px",
            padding: "30px",
            textAlign: "center",
            background: isDragging ? "#f0f8ff" : "#fafafa",
            cursor: "pointer",
            transition: "background 0.2s ease",
          }}
        >
          <i className="fa fa-cloud-upload fa-2x mb-2" aria-hidden="true"></i>
          <p className="mb-0">
            {isDragging ? "Drop files here..." : "Drag & drop files here, or click to select"}
          </p>
        </div>
      </div>

      {documents.length > 0 && (
        <div className="file-preview">
          {documents.map((file, index) => (
            <div key={index} className="file-preview-item ml-2">
              <span>{file.name}</span>
              <span
                className="file-size"
                style={{
                  backgroundColor: "#f0f0f0",
                  marginLeft: "10px",
                  padding: "2px 5px",
                  borderRadius: "5px",
                }}
              >
                {file.size} KB
              </span>
              <button
                className="btn btn-sm btn-link"
                onClick={() => handleFileRemove(file)}
              >
                <i className="fa fa-times text-red" aria-hidden="true"></i>
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="col-md-12 form-group">
        <label htmlFor="message" className="form-control-label">
          Message
        </label>
        <textarea
          name="message"
          id="message"
          cols="5"
          rows="3"
          className="form-control"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        ></textarea>
      </div>

      <div className="col-12 text-center mt-3 d-flex justify-content-center">
        {/* File upload button (hidden input) */}
        {/* <Button
          variant="outline-dark"
          size="sm"
          onClick={() => fileInputRef.current.click()}
        >
          <i className="fa fa-paperclip mr-2" aria-hidden="true"></i>
          Add
        </Button> */}

        <Button variant="outline-dark" size="sm" onClick={handleSubmit}>
          <i className="fa fa-paper-plane-o mr-2" aria-hidden="true"></i>
          Send
        </Button>
      </div>

      <input
        type="file"
        ref={fileInputRef}
        onChange={messgeOnFileChange}
        multiple
        style={{ display: "none" }}
      />
    </div>
  );
};

export default MsgWithApplicantPopup;
